module.exports = __webpack_public_path__ + "img/icon-differentials_06.02634fe7.svg";